export const normalizeApiResponse = (response = {}) => ({
  success: response.success ?? response.Success ?? false,
  message: response.message ?? response.Message ?? '',
  data: response.data ?? response.Data ?? null,
});

export default {
  normalizeApiResponse,
};

